import { IDay, IStoreData, Store } from '@df/catalog/store/store';
import { StoreResource } from '@df/catalog/store/store.resource';
import { isSameDay } from '@df/util/fn/is-same-day';
import { GMTDateToUK } from '@df/util/fn/uk-date';

declare module '@df/catalog/store/store' {
    interface IStoreDataV1 {
        region?: string;
        first_pickup_date?: string;
        suburb: string;
    }
}

export class StoreDecorator<T extends IStoreData = IStoreData> extends Store<T> {
    get secondLine(): string {
        if (this.data) {
            return [this.data.city, this.data.region, this.data.postcode].filter(i => !!i).join(', ');
        }
        return '';
    }

    get collectionDate(): string | undefined {
        if (this.data) {
            return this.data.first_pickup_date;
        }
        return undefined;
    }
    /**
     * If store is open now
     */
    override get isOpenNow(): boolean {
        const hours = this.todayOpeningHours;
        if (!hours) {
            return false;
        }
        const date = new Date();
        GMTDateToUK(date);
        const h = (date.getUTCHours() + '').padStart(2, '0') + ':' + (date.getUTCMinutes() + '').padStart(2, '0');
        return hours?.status === 1 && hours.open <= h && hours.close > h;
    }

    override get isOpenToday(): boolean {
        const hours = this.todayOpeningHours;
        
        return hours && !!(hours.open && hours.open !== 'CLOSED');
    }

    get nextOpenDay(): IDay | undefined {
        return this.openingHours
            ?.sort((a: IDay, b: IDay) => a.date?.getTime() - b.date.getTime())
            .find(day => {
                if (!day.holiday && day.status !== 2) {
                    if (isSameDay(day.date, new Date())) {
                        return this.willBeOpenToday(day);
                    }
                    return true;
                }
                return false;
            });
    }
    get isNextOpenDayToday(): boolean {
        if (this.nextOpenDay?.date) {
            return isSameDay(this.nextOpenDay.date, new Date());
        }
        return false;
    }
    get nextOpenDayName(): string {
        return this.nextOpenDay?.date?.toLocaleDateString('en-UK', { weekday: 'long' }) || '';
    }

    private willBeOpenToday(day: IDay): boolean {
        if (day.status !== 1) {
            return false;
        }
        const date = new Date();
        GMTDateToUK(date);
        const h = (date.getUTCHours() + '').padStart(2, '0') + ':' + (date.getUTCMinutes() + '').padStart(2, '0');
        return day.open >= h;
    }
}

StoreResource.instance = StoreDecorator;
